import { reverse } from 'named-urls'
import React from 'react'
import { Link } from 'react-router-dom'

import type { TableData } from '@fourthwall/components'
import { EmptyState, List, Table, useMediaQueryContext } from '@fourthwall/components'
import { CollectionListItem } from '@modules/Dashboard/Collections/components/CollectionListItem'
import type { Collection } from '@modules/Dashboard/Collections/types'
import { routing } from '@utils/routing'

import { TABLE_HEADERS } from './consts'

type CollectionsTableProps = {
  data: TableData<Collection>[]
  isLoading: boolean
}

const getRowLink = (collection: any) => ({
  pathname: reverse(routing.products.collections.collection.self, {
    collectionId: collection.id,
  }),
  search: location.search,
})

export const CollectionsData = ({ data, isLoading }: CollectionsTableProps) => {
  const media = useMediaQueryContext()

  const emptyComponent = (
    <EmptyState
      title="You haven’t created any collections yet"
      subtitle="Group your products or create categories."
      label="Create new collection"
      variant={media.tablet ? 'primary' : 'secondary'}
      to={routing.products.collections.create.self}
    />
  )

  if (!media.tablet) {
    return (
      <List
        data={data}
        isLoading={isLoading}
        emptyComponent={emptyComponent}
        renderItem={({ name, offerIds, primaryImg, state, timeFrame }: Collection) => (
          <CollectionListItem
            name={name}
            quantity={offerIds.length}
            photoUrl={primaryImg?.thumbnailUrl}
            status={state.status}
            timeFrame={timeFrame}
          />
        )}
        getItemLink={getRowLink}
      />
    )
  }

  return (
    <Table
      headers={TABLE_HEADERS}
      data={data}
      emptyComponent={emptyComponent}
      isLoading={isLoading}
      rowComponent={Link}
      getRowLink={getRowLink}
    />
  )
}
